
import HeroSection from './components/HeroSection';
import TradingSpecsSection from './components/TradingSpecsSection';
import ContractDetailsSection from './components/ContractDetailsSection';
import TradingHoursSection from './components/TradingHoursSection';
import MarginRequirementsSection from './components/MarginRequirementsSection';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function MarketPage() {
  return (
    <div className="min-h-screen">
            <Header />
      <HeroSection />
      <TradingSpecsSection />
      <ContractDetailsSection />
      <TradingHoursSection />
      <MarginRequirementsSection />
            <Footer />
    </div>
  );
}
